module.exports = __webpack_public_path__ + "img/archive.c6125b9b.svg";